import React from 'react';
import { Grid } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export interface HomepageTemplateProps {
  AppBar: React.JSX.Element;
  Header?: React.JSX.Element;
  TitleLeftPart?: React.JSX.Element;
  TitleRightPart?: React.JSX.Element;
  Body: React.JSX.Element;
}

const HomepageTemplate: React.FC<HomepageTemplateProps> = ({
  AppBar,
  Body,
}) => {
  // styles
  const useStyles = makeStyles()({
    bodyContainer: {
      margin: '48px 130px',
    },
  });
  const { classes } = useStyles();

  return (
    <>
      {AppBar}
      <Grid className={classes.bodyContainer}>{Body}</Grid>
    </>
  );
};

export default HomepageTemplate;
